import React, { useState } from 'react';
import { styles } from './WishlistCard.css';
import Card from '@jbhi-fi/lanyard-ui/components/Card';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { Close } from '@jbhi-fi/lanyard-ui/components/Icons';
import { IconName } from '@jbhi-fi/lanyard-ui/components/Icon';
import { trackAddToWishlist } from '@jbhi-fi/utils/src/ga4Tracking';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';
import { EcommerceCartItem } from '@jbhi-fi/utils/src/ga4Tracking/types';

export type WishlistCardProps = {
  productName: string;
  product_image: string;
  isSaved: boolean;
  trackingData?: EcommerceCartItem;
  onWishlistClick: () => Promise<void> | void;
  onClose: () => Promise<void> | void;
  location?: string;
  variant?: 'cart' | 'miniCart';
};

export const WishlistCard = ({
  productName,
  product_image,
  isSaved,
  trackingData,
  location = '',
  variant = 'cart',
  onWishlistClick,
  onClose,
}: WishlistCardProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleWishlistClick = async () => {
    setIsLoading(true);
    try {
      await onWishlistClick();
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  const getIconProps = (): { name: IconName; color?: string } => {
    if (isLoading) {
      return {
        name: 'Loading',
      };
    }
    return {
      name: isSaved ? 'Heart' : 'HeartEmpty',
      color: isSaved ? palette.error.main : palette.primary.dark,
    };
  };

  const onAddToWishlist = () => {
    if (!isSaved) {
      trackAddToWishlist({
        currency: getStoreCurrency(),
        item: trackingData,
        location,
      });
      handleWishlistClick();
    }
  };

  return (
    <Card
      className={styles.wishlistCard({ variant })}
      shadow={0}
      backgroundColor={palette.info.light}
      shadowColor={palette.info.light}
      data-testid="cart-wishlist-card"
    >
      <div className={styles.closeButtonContainer}>
        <Button type="iconOnly" onClick={onClose} icon={<Close />} />
      </div>
      <div className={styles.content}>
        <h2 className={styles.heading}>Would you like to save this to your Wishlist?</h2>
        <div className={styles.productInfo}>
          <img alt="productImage" src={product_image} className={styles.productImage}></img>
          <span className={styles.productTitle}>{productName}</span>
        </div>
        <div className={styles.actions}>
          <Button
            classes={styles.wishlistButton}
            type="linkWithIcon"
            label={`Save${isSaved ? 'd' : ''} to wishlist`}
            icon={<Icon {...getIconProps()} />}
            iconPosition="left"
            onClick={onAddToWishlist}
            data-testid="cart-wishlist-button"
          />
        </div>
      </div>
    </Card>
  );
};
